export default __webpack_public_path__ + "static/media/IoTs.544d2dc5.png";